<template>
    <a
        v-if="addedClass !== 'single_item'"
        :href="(basic.linkUrl ? basic.linkUrl.url : '')"
        :target="basic.linkUrl ? basic.linkUrl.target : '_self'"
        :id="advanced.cssId"
        :class="['btn', advanced.cssClasses, advanced.displayType, responsiveClasses]"
        :style="style"
    >
        <span class="btn-headline">{{basic.content || 'Button'}}</span>
        <div v-if="basic.subHeadline" class="btn-sub-headline" :style="subStyle">
            {{basic.subHeadline}}
        </div>
    </a>
    <a
        v-else
        :id="advanced.cssId"
        :class="['btn', advanced.cssClasses, addedClass, advanced.displayType, responsiveClasses]"
        :style="style"
        @click="$emit('changeStep')"
    >
        <span class="btn-headline">{{basic.content || 'Button'}}</span>
        <div
            v-if="basic.subHeadline"
            class="btn_sub_headline"
            style="display: block; font-size: 12px; opacity: 0.8;"
            :style="subStyle"
        >
            {{basic.subHeadline}}
        </div>
    </a>
</template>

<script>
import {boxShadow, textShadow} from "@/modules/page-editor/src/utils/props";

export default {
    name: 'FormButton',
    props: ['details','addedClass'],
    computed: {
        basic() {
            return this.details.attributes.basic
        },
        advanced() {
            return this.details.attributes.advanced
        },
        responsive() {
            return this.details.responsive
        },
        responsiveClasses() {
            let c = '';
            if (!this.responsive) return '';
            if (!this.responsive.desktop) c = 'no-desktop';
            if (!this.responsive.mobile) c += ' no-mobile';
            if (!this.responsive.tablets) c += ' no-tablet';
            return c;
        },
        textDecoration2(){
            var fontStyling = this.basic.font2 ? this.basic.font2.fontStyling : false;
            if(fontStyling['line-through'] && fontStyling.underline) {
                return 'underline line-through';
            } else if(fontStyling['line-through']) {
                return 'line-through';
            } else if(fontStyling.underline){
                return 'underline';
            } else {
                return 'none';
            }
        },
        subStyle() {
            var fontFamily = this.basic.font2 ? this.basic.font2.fontFamily : 'Roboto';
            var fontSize = this.basic.font2 ? this.basic.font2.fontSize + 'px' : '14';
            var textAlign = this.basic.font2 ? this.basic.font2.textAlign : 'center';
            var fontStyling = this.basic.font2 ? this.basic.font2.fontStyling : false;
            var color = this.basic.font2 ? this.basic.font2.color : '#F6F9FE';

            var obj = {
                color,
                fontFamily,
                fontSize,
                textAlign,
                fontStyling,
                fontWeight: fontStyling.bold ? 'bold' : 'normal',
                fontStyle: fontStyling.italic ? 'italic' : 'normal',
                textDecoration: this.textDecoration2,
            }
            return obj
        },
        textDecoration(){
            var fontStyling = this.basic.font ? this.basic.font.fontStyling : false;
            if(fontStyling['line-through'] && fontStyling.underline) {
                return 'underline line-through';
            } else if(fontStyling['line-through']) {
                return 'line-through';
            } else if(fontStyling.underline){
                return 'underline';
            } else {
                return 'inherit';
            }
        },
        style() {
            var border = this.basic.border;
            var borderTop,
                borderLeft,
                borderRight,
                borderBottom;

            if (border) {
                borderTop = !border.sides.top ? 'none' : border.width + 'px ' + border.style + ' ' + border.color;
                borderLeft = !border.sides.left ? 'none' : border.width + 'px ' + border.style + ' ' + border.color;
                borderRight = !border.sides.right ? 'none' : border.width + 'px ' + border.style + ' ' + border.color;
                borderBottom = !border.sides.bottom ? 'none' : border.width + 'px ' + border.style + ' ' + border.color;
            }

            var borderRadius = border ?
                border.radius.topLeft+'px '+
                border.radius.topRight+'px '+
                border.radius.bottomRight+'px '+
                border.radius.bottomLeft+'px' : false;

            var margin = this.basic.margin ?
                this.basic.margin.top+'px '+
                this.basic.margin.right+'px '+
                this.basic.margin.bottom+'px '+
                this.basic.margin.left+'px' : false;

            var padding = this.advanced.padding ?
                this.advanced.padding.top+'px '+
                this.advanced.padding.right+'px '+
                this.advanced.padding.bottom+'px '+
                this.advanced.padding.left+'px' : false;

            var fontFamily = this.basic.font ? this.basic.font.fontFamily : 'inherit';
            var fontSize = this.basic.font ? this.basic.font.fontSize + 'px' : 'inherit';
            var textAlign = this.basic.font ? this.basic.font.textAlign : 'center';
            var fontStyling = this.basic.font ? this.basic.font.fontStyling : false;
            var color = this.basic.font ? this.basic.font.color : 'inherit';

	        let shadow = boxShadow(this.basic.shadows);
	        let txtshadow = textShadow(this.advanced.textShadows);

            var transform = this.advanced.transformation ?
                'rotateX('+ this.advanced.transformation.rotateX +'deg) ' +
                'rotateY('+ this.advanced.transformation.rotateY +'deg) ' +
                'rotateZ('+ this.advanced.transformation.rotateZ +'deg) ' +
                'scale3d('+this.advanced.transformation.scaleX+', '+this.advanced.transformation.scaleY+', '+this.advanced.transformation.scaleZ+')' : false;

            // var transition = this.advanced.animations ?
            //     this.advanced.animations.duration + 's ' +
            //     this.advanced.animations.property + ' ' +
            //     this.advanced.animations.easing : 'initial';

            var obj = {
                margin,
                padding,
                borderRadius,
                borderTop,
                borderLeft,
                borderRight,
                borderBottom,
                backgroundColor: this.basic.backgroundColor || '#4368E0',
                display: this.advanced.displayType || 'inline-block',
                color,
                fontFamily,
                fontSize,
                textAlign : textAlign  || 'center',
                fontStyling,
                fontWeight: fontStyling.bold ? 'bold' : 'inherit',
                fontStyle: fontStyling.italic ? 'italic' : 'inherit',
                textDecoration: this.textDecoration,
                boxShadow:shadow,
                textShadow:txtshadow,
                transform,
                // transition,
            };
            return obj
        }
    },
    methods:{
    },
}
</script>
